import { render, staticRenderFns } from "./App.vue?vue&type=template&id=1ae698fe&lang=pug&"
import script from "./App.ts?vue&type=script&lang=js&"
export * from "./App.ts?vue&type=script&lang=js&"
import style0 from "./app.sass?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports